<template>
  <el-dialog
    title="Selecionar Conta"
    :before-close="fechar"
    width="80%"
    :visible.sync="visibility"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    @open="iniciar"
  >
    <el-form size="mini" label-position="top">
      <el-row :gutter="20">
        <el-col :md="4" :lg="10">
          <el-form-item label="Plano de Conta">
            <el-autocomplete
              v-model="contaPesquisa.contaPlanoConta.nome"
              :fetch-suggestions="nomePlanoInputHandler"
              :debounce="1000"
              clearable
              @clear="limparNomePlanoInputHandler"
              :trigger-on-focus="false"
              :hide-loading="true"
              popper-class="invisible-autocomplete-popper"
              style="width: 100%">
            </el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :md="4" :lg="10">
          <el-form-item label="Cliente">
            <el-autocomplete
              v-model="contaPesquisa.cliente.nome"
              :fetch-suggestions="nomeClienteInputHandler"
              :debounce="1000"
              clearable
              @clear="limparNomeClienteInputHandler"
              :trigger-on-focus="false"
              :hide-loading="true"
              popper-class="invisible-autocomplete-popper"
              style="width: 100%">
            </el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <h4 style="color: #606266; margin: 0px 15px 5px 0px">Label Quantidade</h4>
      </el-row>
      <el-table
        :data="listaContas"
        @row-click="selecionarConta"
        highlight-current-row
        stripe
        height="250"
        empty-text="Nenhuma conta encontrada">
        <el-table-column label="Status" prop="status" style="font-weight: bold" width="200">
          <template slot-scope="scope">
            <el-row>
              <el-col style="font-weight: bold">
                <span>{{ scope.row.status === 'ABERTA' ? 'Aberta' : 
                         scope.row.status === 'EFETUADO' ? 'Efetuado' :
                         scope.row.status === 'CANCELADO' ? 'Cancelado' :
                         scope.row.status === 'DEVOLVIDO' ? 'Dolvovido' : ''
                   }}</span>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="Conta">
          <template slot-scope="scope">
            <el-row :gutter="10" style="padding: 2px 0px" :style="{ backgroundColor: '#DCDCDC' }">
              <el-col :span="8" style="font-weight: bold">
                <span>{{ scope.row.vencimento }}</span>
              </el-col>
              <el-col :span="8" style="font-weight: bold;">
                <span>{{ util.formatarValor(scope.row.valor) }}</span>
              </el-col>
              <el-col :span="8" style="text-align; font-weight: bold; padding-right: 12px">
                <span>{{ util.formatarValor(scope.row.saldoEmAberto) }}</span>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="24" style="margin: 2px 0px 5px 0px; font-weight: bold">
                {{ scope.row.contaPlanoConta ? scope.row.contaPlanoConta.nome : 'Entrada de cheque no Caixa ' }}
              </el-col>
            </el-row>
            
            <el-row :gutter="24">
              <el-col :span="24" style="margin: 2px 0px 5px 0px">
                {{ scope.row.cliente ? scope.row.cliente.nome : ' - ' }}
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <span slot="footer">
      <el-button @click="fechar" type="primary" size="small" round class="btn-box-shadow">Selecionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'

import Util from '../../util/funcoes'
import { TIPO_DOCUMENTO_CONTA } from '../../util/constantes'

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      planosDisponiveis: [],
      listaContas: [],
      contaPesquisa: {
        contaPlanoConta: {
          nome: undefined,
          grupoPlanoConta: {
            tipo: 'RECEITA'
          }
        },
        cliente: {
          nome: undefined
        },
        status: 'ABERTA',
        pagina: 0
      },
      infiniteLoadingId: 0,
      linhaSelecionada: undefined,
      labelQuantidadeContas: undefined,
      contaSelecionada: undefined,
      loadingContas: false
    }
  },

  computed: {
    util() {
      return Util;
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('contasReceberStore', [
      'listarContasReceber',
      'listarPlanos'
    ]),

    listarContasBancariasHandler() {
      if(typeof(this.contaPesquisa.contaPlanoConta.nome) == 'object') {
        this.contaPesquisa.contaPlanoConta.nome = this.contaPesquisa.contaPlanoConta.nome.nome
      }

      this.showLoading();
      this.listarContasReceber(this.contaPesquisa)
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.listaContas = resultado.lista; 
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem)
            break;
          default:
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      })
    },

    dispararPesquisa() {
      this.listarContasBancariasHandler();
    },

    nomePlanoInputHandler(value) {
      this.contaPesquisa.contaPlanoConta.nome = value;
      this.dispararPesquisa();
    },

    nomeClienteInputHandler(value) {
      this.contaPesquisa.cliente.nome = value
      this.dispararPesquisa();
    },

    iniciar() {
      this.listarContasBancariasHandler();
    },

    fechar() {
      this.$emit('close', this.contaSelecionada)
    },

    selecionarConta(row) {
      this.contaSelecionada = row
    },
    
    filtrarPlanosSelect(queryString) {
      let payload = { nome: queryString, grupoPlanoConta: { tipo: 'RECEITA' } }
      this.loadingContas = true;
      this.listarPlanos(payload)
      .then((response) => {
        this.loadingContas = false;
        this.planosDisponiveis = response.lista
      });
    },

    getLabelTipoDocumento(item) {
      return Util.getLabel(TIPO_DOCUMENTO_CONTA, item)
    },

    limparNomePlanoInputHandler() {
      this.dispararPesquisa();
    },

    limparNomeClienteInputHandler() {
      this.dispararPesquisa();
    }
  }
}
</script>